import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";

// import Table from "../../../../core/common/dataTable/index";
import ApplicationTable from "./ApplicationTable";
import { getApplications } from "../auth/services/privateapicalling";
import { useSelector } from "react-redux";

const ApprovedApmc = () => {
    const [selectedAction, setSelectedAction] = useState("All");
    const userDetails = useSelector((state:any)=>state.auth.userDetails)
    const roleIdentifier = useSelector((state: any) => state.auth.userDetails?.Role?.Role_Identifier);
     const language = useSelector((state:any)=>state.auth.language);
  
      
      const statusOptions = [
         { value: "all_approve", label: "All Application" },
        { value: "schemeGranted", label: "Scheme final Approved by Higher Authority" },    
        { value: "hoclerkAfterApproveAction", label: "Forward to Higher Authority" }, 
         { value: "pendingAtHigherAuthorityApproval", label: "Scheme Forwarded to higher authority" }, 

      ];


    return (
        <>
            {/* Page Wrapper */}
            <div className="page-wrapper">
                <div className="content">
                    {/* Breadcrumb */}
                    <div className="d-md-flex d-block align-items-center justify-content-between page-breadcrumb mb-3">
                        <div className="my-auto mb-2">
                            <h2 className="mb-1">{language.application_list}</h2>
                        </div>
                    </div>
                    {/* /Breadcrumb */}

                    {/* Performance Indicator list */}
                    <div className="card">
                     

                        <div className="card-body p-0">
                            <ApplicationTable status={statusOptions} />
                        </div>
                    </div>
                    {/* /Performance Indicator list */}
                </div>
            </div>
        </>
    );
};

export default ApprovedApmc;
